<div
    class="container"
    [class.edit-mode]="alarmGroupEditMode"
    [class.active-dialog]="isRowActionActive"
    [class.disabled]="!userCanEdit">
    <div class="td group-id" data-cy="alarm-group-table-group-no">
        {{ index + 1 }}
    </div>
    <div class="td name">
        <div class="group-name" data-cy="alarm-group-table-group-name" [class.disabled]="!alarmGroup.name">
            {{ getName() }}
        </div>
        <div class="description" [class.disabled]="!alarmGroup.description" data-cy="alarm-group-table-description">
            {{ getDescription() }}
        </div>
    </div>
    <div class="td trigger">
        <div class="category">
            <div
                class="category-name text-button"
                [class.disabled]="!category"
                data-cy="alarm-group-table-category-name"
                [class.blue-bg]="this.category"
                (click)="editAlarmGroup(); $event.stopPropagation()">
                {{ getCategoryName() }}
            </div>
            <div class="clear-button-wrapper" data-cy="alarm-group-table-clear-button" *ngIf="category?.length > 0">
                <mat-icon
                    style="cursor: pointer"
                    svgIcon="delete"
                    class="delete-icon icon-margin"
                    (click)="resetTriggerCategory(); $event.stopPropagation()">
                </mat-icon>
                <button
                    class="text-button remove-left-padding"
                    (click)="resetTriggerCategory(); $event.stopPropagation()">
                    {{ 'alarm-group.page.table.header.trigger-category.clear' | translate }}
                </button>
            </div>
            <div class="category" *ngIf="!category">
                <div class="category-disabled">
                    {{ 'alarm-group.page.no-category-message' | translate }}
                </div>
                <div class="category-error-wrapper">
                    <div
                        class="category-name text-button red"
                        data-cy="alarm-group-table-select-category-button"
                        (click)="editAlarmGroup(); $event.stopPropagation()">
                        {{ 'alarm-group.page.error-category-message' | translate }}
                    </div>
                    <div class="error-icon" (click)="$event.stopPropagation()">
                        <mat-icon
                            svgIcon="save-error"
                            (mouseenter)="isInfoMessageVisible = true"
                            (mouseleave)="isInfoMessageVisible = false" />
                        <div class="info-message-container" *ngIf="isInfoMessageVisible">
                            <div>
                                {{ 'alarm-group.page.no-trigger-category.message.part1' | translate }}
                            </div>
                            <br />
                            <div>
                                {{ 'alarm-group.page.no-trigger-category.message.part2' | translate }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-options" #optionsIcon>
        <mat-icon
            svgIcon="more-options"
            class="icon"
            data-cy="alarm-group-table-kebab-icon"
            (click)="openOptions(); $event.stopPropagation()"></mat-icon>
        <ng-container *ngIf="optionsVisible">
            <div class="more-options-container" #otherOptions>
                <div
                    class="option-row"
                    data-cy="alarm-group-table-duplicate-button"
                    (click)="duplicateRow(); $event.stopPropagation()">
                    {{ 'alarm-group.table.row.option.duplicate' | translate }}
                </div>
                <div
                    class="option-row"
                    data-cy="alarm-group-table-delete-button"
                    (click)="deleteRow(); $event.stopPropagation()">
                    {{ 'alarm-group.table.row.option.delete' | translate }}
                </div>
            </div>
        </ng-container>
    </div>
</div>
